<template>
  <div class="container">
    <!-- 提示 start-->
    <div class="tips">
      <a-alert
        message="统计计费时间为次日的凌晨01:00"
        description="当前仅显示前一天之前的统计数据"
        type="info"
        show-icon
      />
    </div>
    <!-- 提示 end-->
    <!-- 查询条件区 start -->
    <div class="selectRule">
      <div class="choose-template" style="margin-left: 3%">
        短信平台：
        <j-dict-select-tag
          :selectClear="true"
          placeholder="请选择短信平台"
          dictCode="message_source_code"
          class="width-dict"
          :triggerChange="false"
          v-model="querySource"
        ></j-dict-select-tag>
        短信账号：
        <j-dict-select-tag
          :selectClear="true"
          placeholder="请选择短信账号"
          ref="queryAccountDictRef"
          class="width-dict"
          :triggerChange="false"
          v-model="queryAccount"
        ></j-dict-select-tag>
        模板号：
        <a-select
          allowClear
          show-search
          placeholder="模板号"
          style="width: 20%"
          @select="chooseTemplateCode"
          v-model="queryTemplateCode"
        >
          <a-select-option v-for="(templateItem, index) in templateList" :key="index" :value="templateItem.tempCode">
            <a-tag color="orange">
              {{ templateItem.tempCode }}
            </a-tag>
            <a-tag color="blue">
              {{ templateItem.tempName }}
            </a-tag>
          </a-select-option>
        </a-select>
        时间:
        <a-range-picker @change="getNewDate"  v-model="queryDateModel" style="margin-right: 1%; width: 17%" :default-value="defaultDate" />
        <a-button type="primary" icon="search"  @click="getTableDate"  >查看</a-button>
        <a-button type="primary"   style="margin-left:10px;"  @click="initQuery"  >重置</a-button>
      </div>
    </div>
    <!-- 查询条件区 end -->
    <div>
      <a-button  style="margin-left: 20px;margin-top:20px;" type="primary"   @click="exportExcel" :loading="exproting"  >导出</a-button>
    </div>
    <!-- 结果列表区 start -->
    <div class="selectTable">
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered>
        <span slot="dateFormat" slot-scope="text">
          <p>{{ moment(text).format('YYYY-MM-DD') }}</p>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination
          size="small"
          style="margin-top: 1%; float: right"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <!-- 结果列表区 end -->
  </div>
</template>

<script>
import moment from 'moment'
import { getUserCanReadTemplate, getMessageBillingTablateDate,getAccountNameListDict } from '@/api/api'
import JDictSelectTag from '../../components/dict/JDictSelectTag.vue'
import { downFile } from '@/api/manage'
const columns = [
  {
    title: '模板号',
    dataIndex: 'templateCode',
    key: 'templateCode',
    align: 'center',
  },
  {
    title: '短信平台',
    dataIndex: 'cmSourceType_dictText',
    key: 'cmSourceType_dictText',
    align: 'center',
  },
  {
    title: '短信账号',
    dataIndex: 'cmAccount',
    key: 'cmAccount',
    align: 'center',
  },
  {
    title: '短信分类',
    dataIndex: 'smsType_dictText',
    key: 'smsType_dictText',
    align: 'center',
  },
  {
    title: '统计日期',
    dataIndex: 'createTime',
    key: 'createTime',
    align: 'center',
    scopedSlots: { customRender: 'dateFormat' },
  },
  {
    title: '计费数量',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
  },
]

export default {
  components: { JDictSelectTag },
  data() {
    return {
      columns,
      loading: false,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      dateFormat: 'YYYY-MM-DD',
      //用户可见模板列表
      templateList: [],
      //日期
      defaultDate: [
        moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), this.dateFormat),
        moment(moment(new Date()).format('YYYY-MM-DD'), this.dateFormat),
      ],
      queryDateModel:[
        moment(new Date()).subtract(1, 'month'),
        moment(new Date())
      ],
      querySource:undefined,
      queryAccount:undefined,
      queryTemplateCode: '',
      startDay: '', 
      endDay: '',
      exproting:false,
    }
  },
  mounted() {
    this.endDay = moment(new Date()).format('YYYY-MM-DD')
    this.startDay = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
    this.getUserCanUseTemplate()
    this.getAccountNameList()

  },
  methods: {
    initQuery(){
      this.querySource=null;
      this.queryAccount=null;
      this.queryTemplateCode=null;
      this.endDay = moment(new Date()).format('YYYY-MM-DD')
      this.startDay = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
      this.queryDateModel=[
        moment(new Date()).subtract(1, 'month'),
        moment(new Date())
      ],
      this.getTableDate()
    },
    getAccountNameList(){
      getAccountNameListDict().then((res)=>{
        if(res.code==200){
          let accountDict=res.result.map((item)=>{
            return {
              label:item,
              value:item
            }
          })
          this.$refs.queryAccountDictRef.setCurrentDictOptions(accountDict);
        }
      })
    },
    //日期组件
    moment,
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //修改页容量触发方法
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    //日期修改后重新获取数据
    getNewDate(dates, dateStrings) {
      this.startDay = dateStrings[0]
      this.endDay = dateStrings[1]
    },
    chooseTemplateCode(value) {
      this.queryTemplateCode = value
    },
    getTableDate() {
      this.loading = true
      let queryParams = {
        endTime: this.endDay,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startTime: this.startDay,
      }
      if(this.queryTemplateCode){
        queryParams.templateCode=this.queryTemplateCode
      }
      if(this.queryAccount){
        queryParams.cmAccount=this.queryAccount
      }
      if(this.querySource){
        queryParams.cmSourceType=this.querySource
      }
      getMessageBillingTablateDate(queryParams).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.pageSize = res.result.size
          this.pagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    getUserCanUseTemplate() {
      let queryParams = {
        id: this.$ls.get('Login_Userinfo').id,
      }
      getUserCanReadTemplate(queryParams).then((res) => {
        if (res.success) {
          this.templateList = []
          // this.queryTemplateCode = res.result[0].tempCode
          this.templateList = res.result
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    exportExcel(){
      this.exproting = true
      let queryParams = {
        endTime: this.endDay,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startTime: this.startDay,
      }
      if(this.queryTemplateCode){
        queryParams.templateCode=this.queryTemplateCode
      }
      if(this.queryAccount){
        queryParams.cmAccount=this.queryAccount
      }
      if(this.querySource){
        queryParams.cmSourceType=this.querySource
      }
      let fileName = this.startDay + '到' + this.endDay + '的发送情况汇总'
      //使用jeecg封装好的下载js下载xls
      downFile('/goldenHomeMsgMange//exportXlsByMessageBillingTablateDate', queryParams).then((data) => {
        console.log(data)
        if (!data) {
          this.$message.warning('文件下载失败')
          this.exproting = false
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
          this.exproting = false
          this.$message.success('导出成功')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
          this.exproting = false
          this.$message.success('导出成功')
        }
      })
    }
  },
}
</script>

<style scoped>
.tips {
  height: 100%;
  margin-top: 1%;
  padding-left: 1%;
  padding-right: 1%;
  padding-top: 1%;
}
.container {
  background: #ffffff;
  width: 100%;
  height: 100%;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.selectRule {
  height: 100%;
  margin-top: 1%;
}
.width-dict{
  width: 200px;
}
.selectTable {
  height: 100%;
  margin-top: 1%;
  padding-left: 1%;
  padding-right: 1%;
}
</style>
